import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "akademika/akamont/constants/Routes";
import BaseController from "../sharedControllers/BaseController";

/**
 * @namespace akademika.akamont.pages.measurementUnitDetails
 */
export default class MeasurementUnitDetails extends BaseController {
  route = Routes.MEASUREMENT_UNIT_DETAILS;
  parentRoute = Routes.MEASUREMENT_UNIT_LIST;

  public async onRouteMatched() {
    await this.refreshMeasurementUnitDetails();
  }

  public async refreshMeasurementUnitDetails() {
    await this.fetchModel(
      `api/MeasurementUnit/Find/${this.routeParams.measurementUnitId}`
    );
  }

  public async saveChanges() {
    const oChangesModel = this.getView()?.getModel() as JSONModel;
    await this.saveDataAndShowMessage("api/MeasurementUnit/Edit", {
      body: oChangesModel.getData(),
    });
    this.onNavBack();
  }

  public openConfirmDeleteDialog() {
    this.openDialog("MeasurementUnitConfirmDelete");
  }

  public async onDeleteMeasurementUnit() {
    this.get(
      "api/MeasurementUnit/Delete/" + this.routeParams.measurementUnitId
    );
    this.navTo("measurementUnitList");
  }
}
